
import axios from "axios";
import { getAxiosConfig } from "./axiosConfig";
import dayjs from "dayjs";
import { getPrestadores as getPrestadoresCatalogo, getEspecialidades as getEspecialidadesCatalogo } from "./catalogos";

export interface Prestador {
  codigo: number | string;
  mutual: number | string;
  nombre: string;
  vigente?: boolean;
  filtroEdad?: boolean;
  edadDesde?: number;
  edadHasta?: number;
  [key: string]: any;
}

export interface HorarioPrestador {
  prestador: number | string;
  [key: string]: any;
}

export interface Turno {
  prestador: number | string;
  fecha: string;
  [key: string]: any;
}

export const getPrimerosProximosTurnos = async (
  token: string,
  prestadores: Prestador[],
  horariosPrestadores: HorarioPrestador[],
  mutual: number | string
): Promise<Prestador[]> => {
  let turnos: Turno[] = [];
  let prestadoresFormateados: Prestador[] = [];
  let turnosDisponibles: Turno[] = [];
  const config = getAxiosConfig(token);
  try {
    const response = await axios.get(
      `Turnos/TurnosPrestadorFechaXDia/?mutual=${mutual}&desde=${dayjs().add(1, "day").format("YYYY/MM/DD HH:mm")}&hasta=${dayjs().add(4, "month").format("YYYY/MM/DD HH:mm")}`,
      config
    );
    if (response.data.length !== 0) turnos = response.data;
    if (turnos.length !== 0) {
      turnosDisponibles = turnos.sort((a: Turno, b: Turno) => dayjs(a.fecha).diff(dayjs(b.fecha)));
      prestadores.forEach((prestador: Prestador) => {
        let proximoTurno = turnosDisponibles.find(
          (turno: Turno) => turno.prestador === prestador.codigo
        );
        if (proximoTurno) {
          prestadoresFormateados.push({
            ...prestador,
            mutual: mutual,
            note: proximoTurno.fecha,
          });
        }
      });
    }
  } catch (error: any) {
    throw new Error("Error al obtener los turnos futuros: " + (error?.message || error));
  }
  return prestadoresFormateados;
};

